<script>
  import lodash from 'lodash';
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellNumVialsMixedPerMixingLocation',
    extends: TableCellBase,
    data() {
      return {
        fields: [
          'scit_vials_total',
          'slit_vials_total',
        ],
      };
    },
    computed: {
      actualVialsRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
      },
      actualValueRaw() {
        return this.round(this.getRatio(this.actualVialsRaw, this.monthObj['num_mixing_locations']), 2);
      },
    },
  };
</script>
